export enum ElementAttributeType {
    Invalid = 0,
    Style = 1,
    URL = 2,
    MaxLength = 3,
    Placeholder = 5,
    Text = 6,
    TextStyle = 12,
    DefaultValue = 8,
    SummaryValue = 9,
    IsHidden = 10,
    IsDisabled = 22,
    IsMultiline = 23,
    RequiredMessage = 16,
    PastDateMessage = 17,
    FutureDateMessage = 18,
    InvalidDateMessage = 19,
    InvalidZipCodeMessage = 21,
    ConditionalVisibility = 24,
    Width = 25,
    Height = 26,
    BorderRadiusTopLeft = 27,
    BorderRadiusTopRight = 28,
    BorderRadiusBottomRight = 29,
    BorderRadiusBottomLeft = 30,
    PaddingLeft = 31,
    PaddingTop = 32,
    PaddingRight = 33,
    PaddingBottom = 34,
    BorderLeft = 35,
    BorderTop = 36,
    BorderRight = 37,
    BorderBottom = 38,
    BorderColor = 39,
    HorizontalAlignment = 40,
    BackgroundColor = 41,
    DateFormat = 47,
}
